import * as types from "../actions/ActionTypes";
import { scrub, getErrorMessage, getErrorResponseForLinkedUsers } from "newApp/utilities/ErrorMessageHelper";

export const getInitialState = () => (
    {
        passwordValidationRules: null,
        passwordValidationUserData: null,
        passwordChanged: false,
        serverFailureMessage: undefined,
        isAuthenticated: false,
        user: null
    });

const userReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_ORGANIZATION_SETTINGS_BY_TICKET_SUCCEEDED:
    case types.GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_SUCCEEDED: {
        return Object.assign({}, state, {
            passwordValidationRules: action.settings.passwordSettings,
            passwordValidationUserData: action.settings.passwordValidationUserData
        });
    }
    case types.CHANGE_USER_PASSWORD_SUCCEEDED: {
        return Object.assign({}, state, { passwordChanged: true });
    }
    case types.CHANGE_USER_PASSWORD_FAILED: {
        return Object.assign({}, state, { serverFailureMessage: getErrorMessage(action.error) });
    }
    case types.LINK_USER_FAILED: {
        return Object.assign({}, state, { serverFailureMessage: getErrorResponseForLinkedUsers(action.error) });
    }
    case types.CHANGE_USER_PASSWORD_AND_LOGIN_SUCCEEDED:
        return Object.assign({}, state, { isAuthenticated: true });
    case types.CHANGE_USER_PASSWORD_AND_LOGIN_FAILED: {
        const message = scrub(getErrorMessage(action.error));
        return Object.assign({}, state, { serverFailureMessage: message });
    }
    case types.GET_USER_BY_ID_SUCCEEDED: {
        return Object.assign({}, state, { user: action.user });
    }
    case types.GET_USER_BY_ID_FAILED: {
        return Object.assign({}, state, { serverFailureMessage: getErrorMessage(action.error) });
    }
    default:
        return state;
    }
};

export default userReducer;
